import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import { Avatar, Button, CardHeader, Grid, Menu, Tooltip } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import AppRoutes from "../../route/AppRoutes";
import AppBreadcrumbs from "./shares/AppBreadcrumbs";
import Footer from "./Footer";
import logo from "../assets/LOGO_FID_HORIZONTAL.jpg";
import mini_logo from "../assets/FID_CARRE_2020.png";
import ScrollToTopButton from "./shares/ScrollToTopButton";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import AuthService from "../../service/AuthService";
import { useUser } from "../../context/userContext";
import { getBackendProfilePictureLink } from "../../Helpers/utilsHelper";
import { AdminPanelSettingsOutlined } from "@mui/icons-material";
import { jwtDecode } from "jwt-decode";

const drawerWidth = 240;
export const public_url = [
  "/login",
  "/registration",
  "/activate-account",
  "/reset-password",
  "/forgot-password",
  "/etatcivil",
  "/etude",
  "/experience",
  "/competence",
  "/autrecompetence",
  "/fichier",
  "/resume",
  "/administration",
];
const navItems = [
  {
    text: "Offre d'emploi",
    icon: <WorkOutlineOutlinedIcon />,
    link: "/offre-emploi",
  },
  // {
  //   text: "Mes demandes",
  //   icon: <WorkHistoryOutlinedIcon />,
  //   link: "/mes-demandes",
  // },
  // {
  //   text: "Mes associations",
  //   icon: <GroupsOutlinedIcon />,
  //   link: "/mes-associations",
  // },
  { text: "Mon Profil", icon: <Person2OutlinedIcon />, link: "/mon-profile" },
];

const INIT_SETTINGS = [
  {
    titre: "Mon Profil",
    link: "/mon-profile",
    icon: <Person2OutlinedIcon />,
    clickEvt: () => {},
  },
  {
    titre: "Deconnexion",
    link: "/logout",
    icon: <LogoutOutlinedIcon />,
    clickEvt: () => {},
  },
];

export const FID_LOGO = (
  <IconButton
    edge="start"
    color="inherit"
    aria-label="open drawer"
    sx={{ mr: 2, "&:hover": { backgroundColor: "transparent" } }}
    component={Link}
    to={"/"}
  >
    <img src={logo} alt="logo" width="150" />
  </IconButton>
);
export const FID_LOGO_MINI = (
  <IconButton
    edge="start"
    color="inherit"
    aria-label="open drawer"
    sx={{ mr: 2, "&:hover": { backgroundColor: "transparent" } }}
    component={Link}
    to={"/"}
  >
    <img src={mini_logo} alt="logo" width="40" />
  </IconButton>
);

function DrawerAppBar({ fenetre }) {
  const [connectedUser, setConnectedUser] = React.useState({});
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [settings, setSettings] = React.useState(INIT_SETTINGS);
  const { currentUser } = useUser();
  const url = useLocation();
  const navigate = useNavigate();

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = (item) => {
    if (item && item?.titre === "Administrations") {
      window.location.href = process.env.PUBLIC_URL + item.link;
    }
    setAnchorElUser(null);
  };

  React.useEffect(() => {
    if (mobileOpen && fenetre) {
      fenetre().document.body.style.overflow = "hidden";
    }
  }, [mobileOpen, fenetre]);

  const drawer = (
    <Box onClick={handleDrawerToggle} sx={{ textAlign: "center" }}>
      <Typography variant="h6" sx={{ my: 2 }}>
        {FID_LOGO}
      </Typography>
      <Divider />
      <List>
        {navItems.map((item, idx) => (
          <ListItem key={idx} disablePadding>
            <ListItemButton
              sx={{ textAlign: "inherit" }}
              component={Link}
              to={item.link}
              selected={url.pathname.includes(item.link)}
              color={url.pathname.includes(item.link) ? "primary" : ""}
            >
              {item.icon}
              <ListItemText sx={{ pl: 3 }} primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  const handleLogout = () => {
    AuthService.logOut();
    setConnectedUser({});
    setAnchorElUser(null);
    navigate("/login");
  };

  const getConnectedUser = () => {
    try {
      const userInfo = JSON.parse(localStorage.getItem("user"));
      const user = jwtDecode(localStorage.getItem("TOKEN"));
      console.log("role:", String(user.scope).split(":")[1] === "7");

      if (
        String(user.scope).split(":")[1] === "7" &&
        !settings.some((item) => item.titre === "Administrations")
      ) {
        // admin
        let copy_settings = INIT_SETTINGS.slice();
        copy_settings.splice(1, 0, {
          titre: "Administrations",
          link: "/administration",
          icon: <AdminPanelSettingsOutlined />,
        });
        setSettings(copy_settings);
      } else {
        setSettings(INIT_SETTINGS);
      }
      if (user && userInfo) {
        setConnectedUser(userInfo);
      } else {
        setConnectedUser({});
      }
    } catch (e) {
      AuthService.logOut();
    }
  };

  React.useEffect(() => {
    getConnectedUser();
    if (!AuthService.isConnected() && !public_url.includes(url.pathname)) {
      const redirect = encodeURIComponent(
        `${url.pathname}${url.search || ""}${url.hash || ""}`
      );
      navigate(`/login?rdr=${redirect}`);
    }
    if (url.pathname === "/logout") {
      handleLogout();
    }
  }, [url.pathname, navigate]);

  const container =
    fenetre !== undefined ? () => fenetre().document.body : undefined;

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Grid>
          <CssBaseline />
          <AppBar
            component="nav"
            sx={{
              bgcolor: "background.paper",
              color: "text.primary",
              padding: 0.5,
              boxShadow: "none",
              borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
              display: public_url.includes(url.pathname) ? "none" : "",
            }}
          >
            <Toolbar>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ mr: 2, display: { sm: "none" } }}
              >
                <MenuIcon />
              </IconButton>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  flexGrow: 1,
                  display: { xs: "none", sm: "none", md: "block" },
                }}
              >
                {FID_LOGO}
              </Typography>
              <Typography
                variant="h6"
                component="div"
                sx={{
                  flexGrow: 1,
                  display: { xs: "none", sm: "block", md: "none" },
                }}
              >
                {FID_LOGO_MINI}
              </Typography>
              <Box
                sx={{
                  display: {
                    xs: "none",
                    sm: "block",
                    color: "text.primary",
                    textAlign: "center",
                  },
                }}
              >
                {navItems.map((item, idx) => (
                  <Button
                    key={idx}
                    startIcon={item.icon}
                    color={
                      url.pathname.includes(item.link) ? "info" : "inherit"
                    }
                    title={item.text}
                    to={item.link}
                    component={Link}
                    sx={{ mx: 1, textTransform: "capitalize" }}
                  >
                    <Typography
                      sx={{ display: { md: "block", sm: "none", xs: "none" } }}
                    >
                      {item.text}
                    </Typography>
                  </Button>
                ))}
              </Box>
              <Box sx={{ flexGrow: 1 }} textAlign={"right"} ml={2}>
                <Tooltip title={connectedUser.full_name}>
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar
                      alt={String(connectedUser.full_name).toUpperCase()}
                      src={getBackendProfilePictureLink(connectedUser.photo)}
                      sx={{
                        width: 40,
                        height: 40,
                        border: "1px solid #b9b9b9ff",
                      }}
                    />
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  <CardHeader
                    titleTypographyProps={{ fontSize: "12px" }}
                    title={connectedUser.full_name}
                  />
                  <Divider />
                  {settings.map((item, index) => (
                    <ListItem key={index} disablePadding>
                      <ListItemButton
                        sx={{ textAlign: "inherit" }}
                        component={Link}
                        to={item.link}
                        onClick={(e) => handleCloseUserMenu(item)}
                      >
                        {item.icon}
                        <ListItemText sx={{ pl: 3 }} primary={item.titre} />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </Menu>
              </Box>
            </Toolbar>
            <Divider variant="middle" />
            <Box>
              <AppBreadcrumbs />
            </Box>
          </AppBar>
          <nav>
            <Drawer
              container={container}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
              sx={{
                display: { xs: "block", sm: "none" },
                "& .MuiDrawer-paper": {
                  boxSizing: "border-box",
                  width: drawerWidth,
                },
              }}
            >
              {drawer}
            </Drawer>
          </nav>
        </Grid>
      </Box>
      <Grid
        container
        mt={public_url.includes(url.pathname) ? 10 : 15}
        minHeight={"50vh"}
        spacing={1}
        display={"flex"}
        justifyContent="center"
      >
        <Grid
          item
          ml={0.5}
          p={1}
          lg={10}
          display={"flex"}
          justifyContent={"inherit"}
          flexGrow={1}
        >
          <AppRoutes />
        </Grid>
        <Grid height={50} item xs={12} justifyItems={"center"}>
          <Footer />
        </Grid>
      </Grid>
      <ScrollToTopButton />
    </>
  );
}

DrawerAppBar.propTypes = {
  window: PropTypes.func,
};

export default DrawerAppBar;
